module.exports = {"130721100":"洋河南镇","130721101":"深井镇","130721102":"崞村镇","130721103":"沙岭子镇","130721105":"大仓盖镇","130721106":"贾家营镇","130721107":"顾家营镇","130721108":"赵川镇","130721200":"王家湾乡","130721201":"塔儿村乡","130721202":"江家屯乡","130721203":"东望山乡","130721204":"李家堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130721.json
// module id = 166
// module chunks = 0